import { asNullableMeasure, type Measure } from "lab-testing-units";
import { makeAutoObservable } from "mobx";
import type { TestSpecimen } from "@/contracts";
import { SPECIMEN_DEPTH } from "@/contracts/common/units";
import { deepEqual } from "@/utils";

export class SpecimenIdentityModel {
  specimenReference: string | null;
  specimenDepth: Measure | null;
  saveError: string | null = null;
  isSaving = false;
  private serverSnapshot: TestSpecimen | null;

  constructor(source?: Partial<TestSpecimen> | null) {
    this.specimenReference = source?.specimenReference ?? null;
    this.specimenDepth = asNullableMeasure(source?.specimenDepth, SPECIMEN_DEPTH);
    this.serverSnapshot = this.toRequest();
    makeAutoObservable(this, { toRequest: false }, { autoBind: true });
  }

  get isDirty(): boolean {
    return !deepEqual(this.toRequest(), this.serverSnapshot);
  }

  toRequest(): TestSpecimen | null {
    const specimenReference = this.specimenReference?.trim() ?? "";
    if (specimenReference === "") return null;
    return { specimenReference, specimenDepth: this.specimenDepth?.si ?? null };
  }

  setReference(value: string | null) {
    this.specimenReference = value;
  }

  setDepth(value: Measure | null) {
    this.specimenDepth = value;
  }

  setSaving(value: boolean) {
    this.isSaving = value;
  }

  setSaveError(message: string | null) {
    this.saveError = message;
  }

  markSaved(request: TestSpecimen) {
    this.serverSnapshot = request;
    this.saveError = null;
  }
}
